import getCategories from './util/getCategories'
import getSkincareCollections from './util/getSkincareCollections'

import messages from './messages'


const getNavStructureMobile = ({ root, structure }) => {
  if (root === 'skincare') {
    return structure.map(({ children, productsQuery: { gender } }) => ({
      title: gender === 'male' ? messages.men : messages.women,
      subNav: [
        getSkincareCollections({ gender }),
        ...getCategories({ routes: children }),
      ],
    }))
  }

  return getCategories({ routes: structure })
}


export default getNavStructureMobile
